(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["team-favorites-top-button"] && !Shopify.designMode) return;
  try {
    
  class TeamFavoritesTop extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.showAfter = parseInt(this.dataset.showAfter || '280', 10);
      this.onScroll = () => {
        const show = window.scrollY > this.showAfter;
        this.hidden = false;
        this.classList.toggle('is-visible', show);
      };
      this.button?.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }
  }

  if (!customElements.get('team-favorites-top')) {
    customElements.define('team-favorites-top', TeamFavoritesTop);
  }

  } catch(e) { console.error(e); }
})();
})();
